import { GAME_WIDTH, GAME_HEIGHT } from './tuning';

/**
 * Desktop-only mode: the game is tuned for a single fixed aspect ratio and
 * the letterbox renderer (see engine/resize.ts) scales it to fit any viewport.
 * Mobile-specific branches added visual inconsistency between sessions, so
 * they are disabled.
 *
 * `isMobile()` is kept as a named export so existing call sites compile,
 * but it always returns false.
 */
export function isMobile(): boolean {
  return false;
}

/** Retained for API compatibility — always a no-op reset since mobile is off. */
export function resetMobileCache(): void {
  // noop
}

/**
 * Kept for API compatibility. Always 1 — all scale decisions happen at the
 * letterbox layer now, so scenes shouldn't manually down-scale themselves.
 */
export function mobileScale(): number {
  return 1;
}

/** Shorthand: if mobile returns `mobileValue`, else `desktopValue`. Always desktop. */
export function ifMobile<T>(_mobileValue: T, desktopValue: T): T {
  return desktopValue;
}

// Re-export design dims for callers that imported them via this module.
export { GAME_WIDTH, GAME_HEIGHT };
